import React from "react";
import { Link } from "react-router-dom";
import {
  mail_icon,
  github_icon,
  linkedin_icon,
} from "../../assets/svgs/svg-icons.js";
import "../../styles/pages/home.scss";

export default function AboutMe() {
  return (
    <div>
      <h2 className="heading">About Me</h2>
      <div className="subheading">Welcome to my digital garden 🌱</div>
      <p className="body">
        I am a Junior Software Engineer with a drive for innovation and
        problem-solving. Specialising in{" "}
        <span className="highlight-2">Python</span> and{" "}
        <span className="highlight-2">JavaScript</span>, I've led projects
        resulting in streamlined processes and improved user experiences. I am
        driven by a desire to make a positive impact in the areas of technology
        and education, a commitment I have actively embody as a{" "}
        <span className="highlight-2">Tech Mentor at Girls Into Coding</span>{" "}
        and <span className="highlight-2">School Govornor</span>
        . In these roles, I aim to empower women and children, nurture an
        inclusive community, and guide aspiring professionals towards meaningful
        growth and success.
        <br />
        <br />
        In addition to my professional pursuits, I'm an avid glider pilot and
        surfer, hobbies which reflect my love for the outdoors and adventurous
        spirit. These activities not only rejuvenate my mind and body but also
        inspire creativity and resilience, qualities that I bring to my work as
        a professional.
        <br />
        <br />
        <span className="highlight-2">TLDR:</span> I build digital products to
        support business needs 💻
      </p>
      <div class="footer-icons">
        <div className="email">
          <a
            class="footer-icon"
            href="mailto:jk@joycekadibu.com"
            target="blank"
          >
            {mail_icon}
            <span>jk@joycekadibu.com</span>
          </a>
        </div>
        <div>
          <a
            class="footer-icon"
            href="https://linkedin.com/in/jbkad"
            target="blank"
          >
            {linkedin_icon}
            <span>linkedin/jbkad</span>
          </a>
        </div>
        <div>
          <a class="footer-icon" href="https://github.com/jbkad" target="blank">
            {github_icon}
            <span>github/jbkad</span>
          </a>
        </div>
      </div>
    </div>
  );
}
